export default class fullSlideSimple {

    static init() {

        $('.full-slide-simple').slick({
            centerMode: true,
            centerPadding: '60px',
            dots: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<svg class="icon-slide-left"><use xlink:href="#icon-slide-left"></use></svg>',
            nextArrow: '<svg class="icon-slide-right"><use xlink:href="#icon-slide-right"></use></svg>'
        });

    }

}